module.exports = __webpack_public_path__ + "static/sport/swiper-2.1676bd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/swiper/swiper-2.jpg
// module id = pcqw
// module chunks = 0